import { render } from "./Article.vue?vue&type=template&id=2eeb84fe&scoped=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=2eeb84fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2eeb84fe"

export default script